/**
 * components/forces/ForceArrows.tsx — Contenitore delle frecce dei carichi
 * applicati (28-09-2026, richiesta utente).
 *
 * MUTO: deriva le frecce attive da `model/forces.ts` (SOLO in base al valore
 * del carico — NON al flag "incluso nella verifica combinata", vedi
 * doc-comment in cima a quel file) e le mappa su `ForceArrow`. Nessuna
 * dipendenza viewer-only, stesso stile di `components/quotes/Quotes.tsx`.*/

import { useMemo } from "react";
import { FORCE_ARROW_DEFAULTS } from "../../config/defaults";
import type { Vec3 } from "../../data/types";
import { deriveForceArrows, type ForceLoads } from "../../model/forces";
import { ForceArrow } from "./ForceArrow";

export interface ForceArrowsProps {
  /**
   * Punto di ancoraggio — SEMPRE `computeAssemblyMidpoint(scene.connectors.map(c => c.position))`
   * (il centro reale dell'assieme lock, non il riferimento del piano
   * connettore: i carichi sono globali per l'assieme — 28-09-2026, richiesta
   * utente).*/
  origin: Vec3;
  loads: ForceLoads;
  /** Visibilita' del gruppo intero (toggle "Forces" del menu Elements).*/
  visible?: boolean;
}

/** Render dell'intero set di frecce di carico attive, filtrato solo per valore reale.*/
export function ForceArrows({ origin, loads, visible = true }: ForceArrowsProps) {
  const forces = useMemo(
    () => deriveForceArrows(origin, loads, FORCE_ARROW_DEFAULTS.shaftLengthMm),
    [origin, loads],
  );

  return (
    <group visible={visible}>
      {forces.map((force) => (
        <ForceArrow key={force.id} force={force} />
      ))}
    </group>
  );
}
